export const CLAIM_WIZARD_STEPS = [
  { id: 'claimWizardStepEvent', defaultMessage: 'Event' },
  { id: 'claimWizardStepDetails', defaultMessage: 'Details' },
  { id: 'claimWizardStepEvidence', defaultMessage: 'Evidence' },
  { id: 'claimWizardStepContact', defaultMessage: 'Contact' },
  { id: 'claimWizardStepReview', defaultMessage: 'Review' },
];

export const CLAIM_EVENT_OPTIONS = [
  {
    value: 'collision',
    titleId: 'claimWizardEventCollision',
    descriptionId: 'claimWizardEventCollisionDescription',
  },
  {
    value: 'car_damage_from_equipment',
    titleId: 'claimWizardEventDamageFromEquipment',
    descriptionId: 'claimWizardEventDamageFromEquipmentDescription',
  },
  {
    value: 'other',
    titleId: 'other',
    descriptionId: 'claimWizardEventOtherDescription',
  },
];

export const INVOLVED_OPTIONS = [
  { value: 'vehicle_vehicle', labelId: 'claimWizardInvolvedVehicleToVehicle' },
  {
    value: 'vehicle_structure_property',
    labelId: 'claimWizardInvolvedVehicleToStructureProperty',
  },
  { value: 'vehicle_person', labelId: 'claimWizardInvolvedVehicleToPerson' },
];

export const RELATIONSHIP_OPTIONS = [
  { value: 'guest', labelId: 'claimWizardRelationshipGuest' },
  { value: 'driver', labelId: 'claimWizardRelationshipDriver' },
  { value: 'witness', labelId: 'claimWizardRelationshipWitness' },
  { value: 'insurance_representative', labelId: 'claimWizardRelationshipInsuranceRepresentative' },
  { value: 'other', labelId: 'other' },
];

export const getInitialClaimWizardStep = (values, carParts = []) => {
  if (!values?.incidentDetails?.claimChecklist?.eventType) return 0;

  const selectedPart = carParts.find(
    (part) => String(part.id) === String(values.claimDamagePartId)
  );
  const areaOptions =
    selectedPart && Array.isArray(selectedPart.options) ? selectedPart.options : [];
  if (
    !String(values.description || '').trim() ||
    !values.claimDamagePartId ||
    (areaOptions.length && !values.claimDamageAreaId) ||
    !values?.incidentDetails?.claimChecklist?.involved
  ) {
    return 1;
  }

  if (!values?.incidentDetails?.claimChecklist?.eventDate || !values.issueSiteId) return 2;

  if (
    !values?.incidentDetails?.claimChecklist?.primaryContactRelationship ||
    !String(values.customerName || '').trim() ||
    (!String(values.customerPhone || '').trim() && !String(values.customerEmail || '').trim())
  ) {
    return 3;
  }

  return 4;
};
